//-- Copyright (c) 2021 TMT Insights Group, LLC
import React from 'react';
import { Link } from 'react-router-dom';
import { Grid, Typography } from '@mui/material';
import TitleBar from '../_common/TitleBar';
import Breadcrumbs from '../_common/Breadcrumbs';

const ProfileTitleBar = ({ name }) => {
  return (
    <TitleBar>
      <Grid container justifyContent="space-between">
        <Breadcrumbs aria-label="breadcrumb">
          <Link to='/profiles'>Customer Profiles</Link>
          <Typography variant="h3">
            {name}
          </Typography>
        </Breadcrumbs>
      </Grid>
    </TitleBar>
  )
}

export default ProfileTitleBar;